import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, MaxLengthValidator, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { School } from '../schools';

@Component({
    selector: 'app-edit-school-dialog',
    templateUrl: './edit-school-dialog.component.html',
    styleUrls: ['./edit-school-dialog.component.scss'],
})
export class EditSchoolDialogComponent implements OnInit {
    title = 'Schools Editor';
    school: School;
    listofschools: string[];
    schoolEditorForm: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<EditSchoolDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.school = data.school;
        this.listofschools = data.schoolNames;
    }

    ngOnInit(): void {
        this.schoolEditorForm = this.formBuilder.group({
            // id: [this.school.id, ],
            SchoolName: [this.school.schoolName, [Validators.required, isSchoolNameTaken(this.school.schoolName, this.listofschools)]],
            Center: [this.school.center],
            Route: [this.school.route],
            Phone: [this.school.phone, [Validators.maxLength(10)]],
            PhoneExt: [this.school.phoneExt, [Validators.maxLength(10)]],
            _5digit: [this.school._5digit, [Validators.maxLength(5)]],
            Fax: [this.school.fax, [Validators.maxLength(10)]],
            _5digit2: [this.school._5digit2, [Validators.maxLength(5)]],
            Grades: [this.school.grades],
            Area: [this.school.area],
            Principal: [this.school.principal],
            StreetAddress: [this.school.streetAddress],
            City: [this.school.city],
            Zip: [this.school.zip],
            Doegrade1213: [this.school.doegrade1213],
            PreK: [this.school.pk],
            Elem: [this.school.elem],
            Mid: [this.school.mid],
            Sr: [this.school.sr],
            Tech: [this.school.tech],
            Arts: [this.school.arts],
            Adult: [this.school.adult],
            Ese: [this.school.ese],
            Charter: [this.school.charter],
            Choice: [this.school.choice],
            Magnet: [this.school.magnet],
            Ib: [this.school.ib],
            Link: [this.school.link],
            TwoMaps: [this.school.twoMaps],
            PrimaryFunc: [this.school.primaryFunc],
            Doegrade1112: [this.school.doegrade1112],
            EnrollmentPrev: [this.school.enrollmentPrev],
            EnrollmentCurrent: [this.school.enrollmentCurrent],
            Title1: [this.school.title1],
            Bell1: [this.school.bell1],
            Bell2: [this.school.bell2],
            Misc1: [this.school.misc1],
            GKg: [this.school.gKg],
            G01: [this.school.g01],
            G02: [this.school.g02],
            G03: [this.school.g03],
            G04: [this.school.g04],
            G05: [this.school.g05],
            G06: [this.school.g06],
            G07: [this.school.g07],
            G08: [this.school.g08],
            G09: [this.school.g09],
            G10: [this.school.g10],
            G11: [this.school.g11],
            G12: [this.school.g12],
            G31: [this.school.g31],
            District: [this.school.district],
            Programs: [this.school.programs],
            NextYearMap: [this.school.nextYearMap],
            NextYearTwoMap: [this.school.nextYearTwoMap],
            MapAddress: [this.school.mapAddress],
            SchoolPhotoUrl: [this.school.schoolPhotoUrl],
            Latitude: [this.school.latitude],
            Longitude: [this.school.longitude],
            PrevSchoolName: [this.school.prevSchoolName],
            DoeGrade1314: [this.school.doegrade1314],
            Rssfeedlink: [this.school.rssfeedlink],
            Doegrade1415: [this.school.doegrade1415],
            Doegrade1516: [this.school.doegrade1516],
            Doegrade1617: [this.school.doegrade1617],
            WebScreenShotUrl: [this.school.webScreenShotUrl],
            Description: [this.school.description],
            Doegrade1718: [this.school.doegrade1718],
        });

        this.title = this.data.title;
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        console.log(this.schoolEditorForm);
        this.schoolEditorForm.markAllAsTouched();

        if (this.schoolEditorForm.valid) {
            this.school.schoolName = formValues.SchoolName;
            this.school.center = formValues.Center;
            this.school.route = formValues.Route;
            this.school.phone = formValues.Phone;
            this.school.phoneExt = formValues.PhoneExt;
            this.school._5digit = formValues._5digit;
            this.school.fax = formValues.Fax;
            this.school._5digit2 = formValues._5digit2;
            this.school.grades = formValues.Grades;
            this.school.area = formValues.Area;
            this.school.principal = formValues.Principal;
            this.school.streetAddress = formValues.StreetAddress;
            this.school.city = formValues.City;
            this.school.zip = formValues.Zip;
            this.school.doegrade1213 = formValues.Doegrade1213;
            this.school.pk = formValues.PreK;
            this.school.elem = formValues.Elem;
            this.school.mid = formValues.Mid;
            this.school.sr = formValues.Sr;
            this.school.tech = formValues.Tech;
            this.school.arts = formValues.Arts;
            this.school.adult = formValues.Adult;
            this.school.ese = formValues.Ese;
            this.school.charter = formValues.Charter;
            this.school.choice = formValues.Choice;
            this.school.magnet = formValues.Magnet;
            this.school.ib = formValues.Ib;
            this.school.link = formValues.Link;
            this.school.twoMaps = formValues.TwoMaps;
            this.school.primaryFunc = formValues.PrimaryFunc;
            this.school.doegrade1112 = formValues.Doegrade1112;
            this.school.enrollmentPrev = formValues.EnrollmentPrev;
            this.school.enrollmentCurrent = formValues.EnrollmentCurrent;
            this.school.title1 = formValues.Title1;
            this.school.bell1 = formValues.Bell1;
            this.school.bell2 = formValues.Bell2;
            this.school.misc1 = formValues.Misc1;
            this.school.gKg = formValues.GKg;
            this.school.g01 = formValues.G01;
            this.school.g02 = formValues.G02;
            this.school.g03 = formValues.G03;
            this.school.g04 = formValues.G04;
            this.school.g05 = formValues.G05;
            this.school.g06 = formValues.G06;
            this.school.g07 = formValues.G07;
            this.school.g08 = formValues.G08;
            this.school.g09 = formValues.G09;
            this.school.g10 = formValues.G10;
            this.school.g11 = formValues.G11;
            this.school.g12 = formValues.G12;
            this.school.g31 = formValues.G31;
            this.school.district = formValues.District;
            this.school.programs = formValues.Programs;
            this.school.nextYearMap = formValues.NextYearMap;
            this.school.nextYearTwoMap = formValues.NextYearTwoMap;
            this.school.mapAddress = formValues.MapAddress;
            this.school.schoolPhotoUrl = formValues.SchoolPhotoUrl;
            this.school.latitude = formValues.Latitude;
            this.school.longitude = formValues.Longitude;
            this.school.prevSchoolName = formValues.PrevSchoolName;
            this.school.doegrade1314 = formValues.DoeGrade1314;
            this.school.rssfeedlink = formValues.Rssfeedlink;
            this.school.doegrade1415 = formValues.Doegrade1415;
            this.school.doegrade1516 = formValues.Doegrade1516;
            this.school.doegrade1617 = formValues.Doegrade1617;
            this.school.webScreenShotUrl = formValues.WebScreenShotUrl;
            this.school.description = formValues.Description;
            this.school.doegrade1718 = formValues.Doegrade1718;

            this.dialogRef.close(this.school);
            this.schoolEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted SchoolName already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing SchoolName, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isSchoolNameTaken(name: string, listOfSchools: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        const isNameTaken = listOfSchools.some((value) => value === control.value);
        const error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        return error;
    };
}
